export const costDelivery = (state = 0, action) => {
  switch (action.type) {
    case 'SET_COST_DELIVERY':
      return action.data;
    case 'CLEAR_COST_DELIVERY':
      return {};
    default:
      return state;
  }
};
